export const MAX_PASS_CODE = 6;

export const MESSAGE_SUCESS_PASSWORD_RECOVERY =
  'The password has been changed successfully.';
